module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/1@2x_f214d0accd8e72dacf3e5d6a3e0160c4.png";